// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { INVOICE, DELETE_INVOICE, EDIT_INVOICE, GET_INVOICE, ADD_INVOICE } from '../../../../common/constant'

export const actionInvoices = createAsyncThunk('appInvoices/actionInvoices', async (params, thunkAPI) => {
    return await post(INVOICE, params, thunkAPI)
})

export const actionAddInvoices = createAsyncThunk('appInvoices/actionAddInvoices', async (params, thunkAPI) => {
    return await put(ADD_INVOICE, params, thunkAPI)
})

export const actionGetInvoices = createAsyncThunk('appInvoices/actionGetInvoices', async (params, thunkAPI) => {
    return await post(GET_INVOICE, params, thunkAPI)
})

export const actionEditInvoices = createAsyncThunk('appInvoices/actionEditInvoices', async (params, thunkAPI) => {
    return await post(EDIT_INVOICE, params, thunkAPI)
})

export const actionDeleteInvoices = createAsyncThunk('appInvoices/actionDeleteInvoices', async (params, thunkAPI) => {
    return await post(DELETE_INVOICE, params, thunkAPI)
})

export const appInvoicesSlice = createSlice({
    name: 'appInvoices',
    initialState: {
        //list
        loading: false,
        invoices: null,

        //add
        loadingAdd: false,
        addInvoices: null,

        //get
        loadingGet: false,
        getInvoices: null,

        //edit
        loadingEdit: false,
        editInvoices: null,

        //delete
        loadingDelete: false,
        deleteInvoices: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetInvoicesResponse: (state) => {
            state.invoices = null
        },
        resetAddInvoicesResponse: (state) => {
            state.addInvoices = null
        },
        resetGetInvoicesResponse: (state) => {
            state.getInvoices = null
        },
        resetEditInvoicesResponse: (state) => {
            state.editInvoices = null
        },
        resetDeleteInvoicesResponse: (state) => {
            state.deleteInvoices = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionInvoices.pending, (state) => {
                state.loading = true
            })
            .addCase(actionInvoices.fulfilled, (state, action) => {
                state.loading = false
                state.invoices = action.payload
            })
            .addCase(actionInvoices.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddInvoices.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddInvoices.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addInvoices = action.payload
            })
            .addCase(actionAddInvoices.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetInvoices.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetInvoices.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getInvoices = action.payload
            })
            .addCase(actionGetInvoices.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditInvoices.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditInvoices.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editInvoices = action.payload
            })
            .addCase(actionEditInvoices.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteInvoices.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteInvoices.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteInvoices = action.payload
            })
            .addCase(actionDeleteInvoices.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetInvoicesResponse, resetAddInvoicesResponse, resetGetInvoicesResponse, resetEditInvoicesResponse, resetDeleteInvoicesResponse } = appInvoicesSlice.actions

export default appInvoicesSlice.reducer